var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.diagram)?_c('div',{staticClass:"gantt-wrapper my-5"},[(_vm.showGantt)?_c('VueMermaidString',{staticClass:"mermaid",attrs:{"value":_vm.diagram}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }